export const generateRecaptchaHeaders = (token: string, action: string) => {
  return { 'x-recaptcha-token': token, 'x-recaptcha-action': action };
};
